export const CORE_ACTION_FEATURE_TOGGLES_FETCH_PUBLIC = "core/ACTION_FEATURE_TOGGLES_FETCH_PUBLIC";
export const CORE_ACTION_FEATURE_TOGGLES_FETCH_PRIVATE = "core/ACTION_FEATURE_TOGGLES_FETCH_PRIVATE";
export const CORE_GETTER_FEATURE_TOGGLES_GET = "core/GETTER_FEATURE_TOGGLES_GET";
export const CORE_GETTER_FEATURE_TOGGLES_MANAGER_GET = "core/GETTER_FEATURE_TOGGLES_MANAGER_GET";
export const CORE_GETTER_FEATURE_TOGGLES_HAS_FEATURE = "core/GETTER_FEATURE_TOGGLES_HAS_FEATURE";
export const CORE_MUTATION_FEATURE_TOGGLES_SET = "core/MUTATION_FEATURE_TOGGLES_SET";
